import WorkItemData from '@Components/WorkItemV2/work-item-data'
import React, { useContext } from 'react'
import Navigation from '@App/navigation'
import ExtendedWorkItem from '@Components/WorkItemV2/ExtendedWorkItem'
import ShareDisplay from '@Components/WorkItemV2/ShareDisplay'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import RequestUpdateSharesButton from './RequestUpdateSharesButton'
import './index.scss'

const SongwriterCatalogExtendedWorkItem = ({ work, handleOnClick }: WorkItemData) => {
    const { songwriterStore } = useContext<RootStore>(StoresContext)
    const totalSharesTooltipText =
        work.totalKnownShares < 100
            ? 'Part of these shares is unknown, so the total is less than 100%.'
            : 'This reflects total claimed shares on this work by all parties.'

    const fields = [
        { title: 'MLC Song Code', value: work.songCode },
        { title: 'ISWC', value: work.iswc },
    ]

    if (work.rightsholderProprietaryId) {
        fields.push({ title: 'Member Work Identifier', value: work.rightsholderProprietaryId })
    }

    const catalogPath = Navigation.songwriter.catalog.viewWork(songwriterStore.currentSongwriterId, work.id ?? '')
    const requestUpdateSharesPath = Navigation.songwriter.catalog.requestUpdateShares(
        songwriterStore.currentSongwriterId,
        work.id ?? ''
    )

    return (
        <div className="songwriter-extended-work-item-wrapper">
            <ExtendedWorkItem work={work} fields={fields} catalogPath={catalogPath} handleOnClick={handleOnClick}>
                <div className="songwriter-catalog-share-actions">
                    <ShareDisplay
                        share={work.totalKnownShares}
                        highlight
                        tooltip={<CustomToolTip title="Total Known Shares:" info={totalSharesTooltipText} />}
                    />
                    <RequestUpdateSharesButton to={requestUpdateSharesPath} />
                </div>
            </ExtendedWorkItem>
        </div>
    )
}

export default SongwriterCatalogExtendedWorkItem
